<template>
  <b-card>
    <div
      v-if="mostrarAvisoSN"
      class="aviso-sn"
    >
      <p>Nenhuma equipe marcada como Simples Nacional</p>
    </div>
    <equipe-list
      ref="equipeList"
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :filtros="filtros"
      @carregado="verificaSN($event)"
      @removerItem="remover($event)"
    >
      <template slot="botoes-adicionais">
        <filtro-adicional-base
          :target="'popover-filtro-adicional-equipe'"
          @limpar="limpar()"
          @aplicar-busca="aplicar()"
        >
          <template #conteudo-filtro-adicional>
            <b-row>
              <b-col cols="12">
                <b-form-group label="ID Omie">
                  <v-select
                    v-model="valueFiltro.buscaVinculoOmie"
                    :options="[{value: 0, label: 'Com ID Omie'}, {value: 1, label: 'Sem ID Omie'}]"
                    multiple
                    :reduce="omie => omie.value"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </filtro-adicional-base>
      </template>
      <template
        slot="celula-personalizada"
        slot-scope="{props}"
      >
        <span v-if="props.column.label === 'Rodízio'">
          {{ props.row.participaRodizioEquipe ? 'Sim' : 'Não' }}
        </span>
      </template>
    </equipe-list>
  </b-card>
</template>

<style lang="scss">
.aviso-sn{
  text-align: center;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 1rem;

  p{
    margin:0
  }
}
</style>

<script>
import '@core/scss/vue/libs/vue-select.scss'
import vSelect from 'vue-select'
import api from '@/app-modulo/comuns/equipe/shared/services/api'

export default {
  name: 'EquipeVisualizacao',
  components: {
    EquipeList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
    FiltroAdicionalBase: () => import('@/shared/components/filtro-adicional-base/FiltroAdicionalBase.vue'),
    vSelect,
  },
  data() {
    return {
      colunasListagem: [
        { label: 'Equipe', field: 'nome', editable: true },
        {
          label: 'Rodízio', field: 'participaRodizioEquipe', type: 'personalizada', sortable: false,
        },
      ],
      filtros: [{ colunas: ['Nome', 'Rodizio'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      mostrarAvisoSN: false,
      valueFiltro: {
        buscaVinculoOmie: [],
      },
      carregado: false,
    }
  },
  methods: {
    carregar(page, pageSize, filtro) {
      this.carregado = true
      const filtros = {
        filtroPricipal: filtro,
        filtrosAdicionais: this.valueFiltro,
      }
      return api.getEquipes(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-equipe' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-equipe', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteEquipe(item.id)
            .then(() => {
              // tenporario
              if (i === itensInner.length - 1) {
                resolve()
              }
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    verificaSN(dados) {
      const equipeSN = dados.find(f => f.simplesNacional)
      this.mostrarAvisoSN = !equipeSN
    },
    limpar() {
      this.valueFiltro = {
        buscaVinculoOmie: [],
      }
    },
    aplicar() {
      this.$refs.equipeList.montarGrid()
    },
  },
}
</script>
